import * as React from "react";
import { cn } from "@/lib/utils";

/** A multi-line field. Same border, focus, and disabled treatment as Input. */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "flex min-h-20 w-full min-w-0 resize-y rounded-md border border-input bg-card px-3 py-2 text-sm leading-5 text-foreground transition-colors outline-none",
        "placeholder:text-muted-foreground hover:border-foreground/45",
        "focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ring",
        "disabled:cursor-not-allowed disabled:border-border disabled:bg-muted disabled:text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
